import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-timer',
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss']
})
export class TimerComponent implements OnInit {

  showMin = true;
  showTimer = true;
  minute;
  secend;
  timer;
  @Output() notifyStop: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }
  stopTimer() {
    clearInterval(this.timer);
    this.minute = 0;
    this.secend = 0;
    this.showTimer = false;
    this.notifyStop.emit();
  }

  startTimer(min, sec) {
    this.showTimer = true;
    if (min === 0) {
      this.showMin = false;
    }
    this.minute = min;
    this.secend = sec;
    this.timer = setInterval(() => {
      if (this.secend > 0) {
        this.secend--;
        if (this.secend === 0 && this.minute > 0) {
          this.secend = 59;
          this.minute--;
        } else if (this.minute === 0 && this.secend === 0) {
          this.stopTimer();
        }
      }
    }, 1000);
  }
}
